import { IRecord, IRecordType } from 'annotation-tools/utils';
import { IUser, IUserType } from './user';

// immutable object generator
export const ILoginResponse = IRecord<LoginResponseType>({
  token: '',
  user: IUser()
});

// immutable type
export type ILoginResponseType = IRecordType<LoginResponseType>;

type LoginResponseType = {
  token: string;
  user: IUserType;
};
